import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { SiGmail, SiLinkedin, SiFacebook, SiGithub} from "react-icons/si";
import { RiFilePaperLine} from "react-icons/ri";
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { Link } from 'react-router-dom'
import { Button } from 'bootstrap';

const styleObj = {
  fontSize: 24,
  color: "#fff",
  textAlign: "left",
}

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const form = useRef()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) => {
    e.preventDefault()

    emailjs
      .sendForm(
        'service_421nqqs',
        'template_f9uzrcm',
        form.current,
        'W1qUAGWKrv-eEY4QT'
      )
      .then(
        () => {
          alert('Message successfully sent!')
          window.location.reload(false)
        },
        () => {
          alert('Failed to send the message, please try again')
        }
      )
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p style={styleObj}>
            Don't hesitate to contact me using below form.
            Also please check out the cards on the right for more Links.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          <SiGmail size="5rem"/>
          <br />
          <br />
          Business Email:
          <br />
          tsewinsor@gmail.com <br />
          Alt Email: <br />
          <span>windsword27@gmail.com</span>
        </div>
        <div className="info-map2">
        <SiFacebook size="5rem"/>
          <br />
          <br />
          <a href="https://www.facebook.com/winsor.tse/"> Link to Facebook</a>
          <br />
          <br />
        </div>
        <div className="info-map3">
        <SiLinkedin size="5rem"/>
          <br />
          <br />
          <a href="https://www.linkedin.com/in/winsor-tse-ab1603194/"> Link to LinkedIn</a>
          <br />
          <br />
        </div>
        <div className="info-map4">
          <SiGithub size="5rem"/>
          <br />
          <br />
          <a href="https://github.com/winsor-tse"> Link to Github</a>
          <br />
          <br />
        </div>
        <div className="info-map5">
        <RiFilePaperLine size="5rem"/>
          <br />
          <br />
          <a href="https://github.com/winsor-tse/Resumepdf" color="#000"> Link to Resume</a>
          <br />
          <br />
        </div>
        {/*
        <div className="map-wrap">
          <MapContainer center={[44.96366, 19.61045]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[44.96366, 19.61045]}>
              <Popup>Sloba lives here, come over for a cup of coffee :)</Popup>
            </Marker>
          </MapContainer>
        </div>
        */}
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
